import { Component, OnInit, Input } from '@angular/core';
import {
  MemberCard,
  MemberCardQuery,
  MemberDetails,
  Balance,
  MemberQuery,
  BalanceQuery,
  config,
  CardToken,
  CardTokenQuery,
  PopulationQuery,
} from '@fgb/core';
import { Observable } from 'rxjs';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-member-card',
  templateUrl: './member-card.component.html',
  styleUrls: ['./member-card.component.scss'],
})
export class MemberCardComponent implements OnInit {
  @Input() showLanguage: false;
  @Input() showLogo: true;
  @Input() isNav: false;

  memberCard$: Observable<MemberCard | undefined>;
  memberDetails$: Observable<MemberDetails | undefined>;
  balance$: Observable<Balance>;
  member$: Observable<MemberDetails | undefined>;
  combinedCard$: Observable<number | undefined>;
  cardToken$: Observable<CardToken | undefined>;
  population = Populations;
  isKid: boolean;

  constructor(
    private memberCardQuery: MemberCardQuery,
    private memberQuery: MemberQuery,
    private balanceQuery: BalanceQuery,
    private cardTokenQuery: CardTokenQuery,
    private populationQuery: PopulationQuery
  ) {}

  ngOnInit() {
    this.memberCard$ = this.memberCardQuery.selectCurrentCard();
    this.combinedCard$ = this.balanceQuery.selectPurse(config.purseConfig.combined);
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.cardToken$ = this.cardTokenQuery.selectDefaultCard();
    this.isKid = this.populationQuery.userInPopulation(['Kids']);
  }
}
